import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'nx-ng-basket-subscribe-save-banner',
  templateUrl: './basket-subscribe-save-banner.component.html',
  styleUrls: ['./basket-subscribe-save-banner.component.scss'],
})
export class BasketSubscribeSaveBannerComponent {
  @Input()
  title = '';

  @Input()
  text = '';

  @Input()
  currentPrice = 0;

  @Input()
  savePrice = 0;

  @Output()
  click: EventEmitter<void> = new EventEmitter<void>();

  handleClick() {
    this.click.emit();
  }
}
